export const SPEC_STAFF_OPTIONS = [
  "kpi",
  "code",
  "position",
  "futureNumber",
  "standardNumber",
  "factNumber",

  "personRequiredTraining",
  "percentRequiredTraining",
  "personTrained",
  "percentTrained",

  "personRequiredCertificated",
  "percentRequiredCertificated",
  "personCertificated",
  "percentCertificated",

  // TODO PASDILER-2428: столбцы лицензий временно скрыты до завершения работ в feat/PASDILER-1829. https://task.sotl.group:8443/browse/PASDILER-2428
  // "licensesIssued",
  // "licensesRemainder",
];
export const STAFF_OPTIONS = ["code", "position", "method"];
